import mitt from 'mitt';
import { useEffect } from 'react';

export const eventBus = mitt();

eventBus.once = (type, handler) => {
  const wrapper = (...args) => {
    handler(...args);
    eventBus.off(type, wrapper);
  };
  eventBus.on(type, wrapper);
};

export const useEventEmitter = (eventName, handler, deps = []) => {
  useEffect(() => {
    eventBus.on(eventName, handler);

    return () => {
      return eventBus.off(eventName, handler);
    };
  }, deps);
};
